<!--<div>
    <hub-modal-header headerText="Transfer Bike" [activeModal]="activeModal"></hub-modal-header>
</div>-->

<!-- Confirm Transfer Dialog -->
<div class="modal-overlay" *ngIf="showConfirmTransfer">
  <div class="confirm-dialog">
    <!--<div class="confirm-dialog__icon">
      <daz-icon [name]="'warning'" [size]="'32px'" [color]="'#F59E0B'"></daz-icon>
    </div>-->
    <div class="confirm-dialog__title">{{ 'customer.item.edit_item.transfer.confirm_title' | translate }}</div>
    <div class="confirm-dialog__message">
      {{ transferMessage }}
    </div>
    <div class="confirm-dialog__actions">
      <hub-button [text]="'general.cancel' | translate" [style]="'outline'" [size]="'xl'" (buttonClick)="showConfirmTransfer = false"></hub-button>
      <hub-button [text]="'customer.item.edit_item.transfer' | translate" [style]="'secondary'" [size]="'xl'" (buttonClick)="confirmTransfer()"></hub-button>
    </div>
  </div>
</div>

<!-- Transfer Complete Dialog -->
<div class="modal-overlay" *ngIf="showTransferComplete">
  <div class="confirm-dialog">
    <!--<div class="confirm-dialog__icon">
      <daz-icon [name]="'check'" [size]="'32px'" [color]="'#10B981'"></daz-icon>
    </div>-->
    <div class="confirm-dialog__title">{{ 'customer.item.edit_item.transfer.complete_title' | translate }}</div>
    <div class="confirm-dialog__message">
      {{ 'customer.item.edit_item.transfer.complete_message' | translate }}
    </div>
    <div class="confirm-dialog__actions">
      <hub-button [text]="'onboarding.button.done' | translate" [style]="'secondary'" [size]="'xl'" (buttonClick)="completeTransfer()"></hub-button>
    </div>
  </div>
</div>

<div class="modal-content-container">
    <div class="owner-cards">
        <div class="owner-card owner-card--filled">
            <div class="owner-card__avatar">
                <daz-icon [name]="'user'" [size]="'24px'" [color]="'#ffffff'"></daz-icon>
            </div>
            <div class="owner-card__info">
              <div class="owner-card__label">{{ 'customer.item.edit_item.transfer.current_owner' | translate}}</div>
                <div class="owner-card__name">{{(user.Name + ' ' + user.Surname).trim()}}</div>
            </div>
        </div>

        <div class="owner-card owner-card--empty">
            <div class="owner-card__avatar owner-card__avatar--empty">
                <daz-icon [name]="'user'" [size]="'24px'" [color]="'#B0B0B0'"></daz-icon>
            </div>
            <div class="owner-card__info">
              <div class="owner-card__label">{{ 'customer.item.edit_item.transfer.new_owner' | translate}}</div>
                <div class="owner-card__name owner-card__name--placeholder" *ngIf="destinationCustomer == null">{{ 'customer.item.edit_item.transfer.not_selected' | translate}}</div>
                <div class="owner-card__name owner-card__name--placeholder" *ngIf="destinationCustomer !== null">{{ (destinationCustomer.Name + ' ' + destinationCustomer.Surname).trim() }}</div>
            </div>
        </div>
    </div>

    <div class="search-section" *ngIf="!showCreateCustomer && !destinationCustomer">
      <div class="row">

      </div>
      <hub-input [icon]="'search'" [iconColor]="'#888888'" [allowClear]="true"
                 (ngModelChange)="onSearchChange($event)" [(ngModel)]="searchTerm"
                 placeholder="{{ 'bikeshop.cyclist.search_placeholder' | translate }}"></hub-input>
      <div style="max-height: 300px;">
        <div class="empty-state-container" *ngIf="cyclists.length == 0 && !searched && !loading">
          <img src="../../../../../assets/images/no_customers.png" alt="Empty State" class="empty-state-image">
          <div class="empty-state-header-text">{{ "bikeshop.cyclist.start_searching" | translate }} </div>
          <div class="empty-state-header-text">{{ "bikeshop.cyclist.start_searching_details" | translate }}</div>

        </div>
        <div class="results-container">
          <div class="header">
            <div>
              {{results.length}} {{
(results.length === 1 ? 'bikeshop.workshop.jobcard.quote.result' :
            'bikeshop.workshop.jobcard.quote.results') | translate
              }}
            </div>
          </div>
          <div class="search-results" *ngIf="results && results.length > 0 && !loading">
            <div *ngFor="let customer of results" class="search-result-item" (click)="selectedCustomer($event, customer)">
              <div>
                <div class="customer-name">{{customer.Name}} {{customer.Surname}}</div>
                <div class="customer-details">
                  <span>{{customer.Email}}</span>
                  <span *ngIf="customer.Email && customer.PhoneNumber"
                        style="margin-left: 8px;margin-right:8px;">|</span>
                  <span>{{customer.PhoneNumber}}</span>

                  <span *ngIf="customer.ServiceCount && customer.ServiceCount > 0"
                        style="margin-left: 8px;margin-right:8px;">|</span>
                  <span *ngIf="customer.ServiceCount && customer.ServiceCount > 0">{{ 'bikeshop.workshop.jobcard.customer.previous_services' | translate }} => {{customer.ServiceCount}}</span>

                </div>
              </div>
  
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="divider-or" *ngIf="!destinationCustomer">
        <span class="divider-line"></span>
        <span class="divider-text">{{ 'customer.item.edit_item.transfer.or' | translate}}</span>
        <span class="divider-line"></span>
    </div>

    <div *ngIf="!showCreateCustomer && !destinationCustomer" class="add-new-customer-btn">
        <hub-button [text]="'Add New Customer'" [style]="'outline'" [size]="'xl'"
            (buttonClick)="showCreateCustomer = true"></hub-button>
    </div>

    <div *ngIf="showCreateCustomer" class="create-customer-panel">
        <div class="create-customer-panel__header">
          <span class="create-customer-panel__title">{{ 'bikeshop.cyclist.add_cyclist' | translate }}</span>
            <hub-button [style]="'borderless'" [icon]="'cross'" [size]="'sm'"
                (buttonClick)="showCreateCustomer = false"></hub-button>
        </div>

        <div class="create-customer-panel__validation">
          {{ 'customer.item.edit_item.transfer.email_or_phone_required' | translate }}
        </div>

        <div class="create-customer-panel__row">
            <div class="create-customer-panel__field">
                <hub-input [label]="'general.firstname' | translate " [(ngModel)]="firstName"></hub-input>
            </div>
            <div class="create-customer-panel__field">
                <hub-input [label]="'general.surname' | translate " [(ngModel)]="lastName"></hub-input>
            </div>
        </div>

        <div class="create-customer-panel__field">
            <hub-input [label]="'general.phone' | translate " [(ngModel)]="mobileNumber"></hub-input>
        </div>

        <div class="create-customer-panel__field">
            <hub-input [label]="'general.email' | translate " [(ngModel)]="emailAddress"></hub-input>
        </div>

        <div class="create-customer-panel__footer">
            <hub-button [text]="'bikeshop.cyclist.add_cyclist' | translate" [style]="'secondary'" [size]="'xl'" (buttonClick)="createCustomer()"></hub-button>
        </div>
    </div>
</div>

<div class="modal-footer-container">
  <div class="confirm-dialog__message" style="padding-bottom: 16px;">
    {{ transferMessage }}
  </div>
  <div class="footer-actions">
    <hub-button [text]="'Cancel'" [style]="'borderless'" [size]="'xl'" (buttonClick)="clearPage()"></hub-button>
    <hub-button [disabled]="!destinationCustomer" [text]="'customer.item.edit_item.transfer' | translate" [style]="'secondary'" [size]="'xl'" (buttonClick)="transferItem()"></hub-button>
  </div>
</div>
